import { GroupNames } from "../globalHeader/GlobalHeader"

export enum BonusType {
    DAILY_BONUS_HINT = 'DAILY_BONUS_HINT',
    INITIAL_BONUS_HINT = 'INITIAL_BONUS_HINT',
}

type BonusTypeKeys = BonusType

export type BonusTypeRegistry = {
    [key in BonusTypeKeys]?: DailyBonus
}

export interface BonusAmount {
    amount: number
    userType: GroupNames
}

export interface DailyBonus {
    amount: number
    ifEligible: boolean
    availableIn: Date
    name: string
    namespace: BonusType
}

export interface BonusPropositions {
    title?: string
    dailyAmount: number
    initialAmount?: number
    icon?: React.ReactElement
    button: {
        title: string
        color: 'primary' | 'secondary'
        onClick: () => void
    }
}

export interface BonusData {
    isReady: boolean
    content: {
        showLogin: boolean
        nextBonusTime: Date
        timerTitle: string
        propositions: Array<BonusPropositions>
    }
}